import React from "react";
import MarketingLayout from "@/components/marketing/MarketingLayout";
import MarketingPageHero from "@/components/marketing/MarketingPageHero";
import { usePageMeta } from "@/lib/usePageMeta";
import ActualFeatures from "@/components/landing/ActualFeatures";
import Lenses from "@/components/landing/Lenses";
import UseCases from "@/components/landing/UseCases";

export default function Features() {
  usePageMeta(
    "Features — Leadmato",
    "One scan, four answers. Explore Leadmato's Find Customers, Pain Points, Market Analysis and Partners lenses across every supported platform — then save the best leads to your pipeline.",
  );
  return (
    <MarketingLayout>
      <MarketingPageHero
        eyebrow="Features"
        title={<>One scan.<br />Four lenses on your market.</>}
        subtitle="Every Leadmato scan runs through four discovery lenses at once — customers, pain points, market signals and partners — so you get the whole picture from a single query, then save the best leads to your pipeline."
      />
      <ActualFeatures />
      <Lenses />
      <UseCases />
    </MarketingLayout>
  );
}
